import axios from 'axios'
import taskModule from '@/store/modules/calendar/modules/task/module'
import vehiclesModule from '@/store/modules/calendar/modules/vehicles/module'

const calendarModule = {
  modules: {
    calendarTask: taskModule,
    vehiclesModule: vehiclesModule
  },

  state: () => ({
    searchableVehicles: [],
    dailyCellComments: []
  }),

  getters: {
    getSearchableVehicles (state) {
      return state.searchableVehicles
    },

    getDailyCellComments: (state) => (day) => {
      return state.dailyCellComments[day]
    }
  },

  mutations: {
    setSearchableVehicles (state, vehicles) {
      state.searchableVehicles = vehicles
    },

    setDailyCellComments (state, payload) {
      if (!state.dailyCellComments[payload.day]) {
        state.dailyCellComments[payload.day] = payload.comments
      }

      if (payload.reFresh) {
        state.dailyCellComments[payload.day] = payload.comments
      }
    },

    setInitialCalendarLoading (state, isInitial) {
      state.initialCalendarLoading = isInitial
    }
  },

  actions: {
    fetchSearchableVehicles ({ commit, state }, dates) {
      if (localStorage.getItem('accessToken')) {
        const axiosConfig = { headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` } }

        axios.get(`${process.env.VUE_APP_API_BASE_URL}Task/Vehicles/Filtered/Dates?fromDate=${dates.start}&toDate=${dates.end}`, axiosConfig).then(response => {
          commit('setSearchableVehicles', response.data)
        })
      }
    },

    fetchCellComments ({ commit, state }, day) {
      const axiosConfig = { headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` } }

      axios.get(`${process.env.VUE_APP_API_BASE_URL}Comment/${day}`, axiosConfig).then(response => {
        commit('setDailyCellComments', {
          day: day,
          comments: response.data,
          reFresh: true
        })
      })
    },

    fetchDailyCellComments ({ commit, state }, day) {
      if (localStorage.getItem('accessToken') && !state.dailyCellComments[day]) {
        const axiosConfig = { headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` } }

        axios.get(`${process.env.VUE_APP_API_BASE_URL}Comment/${day}`, axiosConfig).then(response => {
          commit('setDailyCellComments', {
            day: day,
            comments: response.data,
            reFresh: false
          })
        })
      }
    }
  }
}

export default calendarModule
